import { createFileRoute, Outlet } from '@tanstack/react-router'

import { AdminMobileHeader } from '#components/layout/admin-mobile-header'
import { AppSidebar } from '#components/layout/app-sidebar'
import { SidebarInset, SidebarProvider } from '#components/ui/sidebar'

export const Route = createFileRoute('/_auth/_admin')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <AdminMobileHeader />
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
